export default {
  lang: 'zh-CN',
  dir: 'ltr',
  common: {
    ok: '确定',
    cancel: '取消',
    key_backspace: '退格',
    key_del: '删除',
    key_down: '下',
    key_up: '上',
    more_opts: '更多选项',
    url: 'URL',
    width: '宽度',
    height: '高度'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: '显示/隐藏更式边线工具',
    palette_info: '点击更改填充颜色，按住Shift键单击更改线条颜色',
    zoom_level: '更改缩放级别',
    panel_action: '点击打开侧边栏',
    quality: '质量:',
    pathNodeTooltip: '拖动节点可移动位置，双击节点可切换线段类型',
    pathCtrlPtTooltip: '拖动控制点以调整曲线形态',
    pick_stroke_paint_opacity: '请选择描边颜色和不透明度',
    pick_fill_paint_opacity: '请选择填充颜色和不透明度',
    group_identify_label: '分组标识标签',
    export_type_label: '选择导出格式:',
    panel: '面板'
  },
  properties: {
    id: '元素ID',
    fill_color: '更改填充颜色',
    stroke_color: '线条的颜色变化',
    stroke_style: '更改线条样式',
    stroke_width: '更改线条宽度',
    pos_x: '更改X坐标',
    pos_y: '更改Y坐标',
    linecap_butt: '顶端样式: 齐平',
    linecap_round: '顶端样式: 圆滑',
    linecap_square: '顶端样式: 方块',
    linejoin_bevel: '连接处: 削平',
    linejoin_miter: '连接处: 直角',
    linejoin_round: '连接处: 圆角',
    angle: '更改旋转角度',
    blur: '更改高斯模糊值',
    opacity: '更改所选条目的不透明度',
    circle_cx: '改变圆的中心X坐标',
    circle_cy: '改变圆的中心Y坐标',
    circle_r: '改变圆的半径',
    ellipse_cx: '改变椭圆的中心X坐标',
    ellipse_cy: '改变椭圆的中心Y坐标',
    ellipse_rx: '改变椭圆的x半径',
    ellipse_ry: '改变椭圆的y半径',
    line_x1: '更改直线起点的x坐标',
    line_x2: '更改直线终点的x坐标',
    line_y1: '更改直线起点的y坐标',
    line_y2: '更改直线终点的y坐标',
    rect_height: '更改矩形的高度',
    rect_width: '更改矩形的宽度',
    corner_radius: '角半径：',
    image_width: '更改图像的宽度',
    image_height: '更改图像的高度',
    image_url: '更改网址',
    node_x: '更改节点的X坐标',
    node_y: '更改节点的Y坐标',
    seg_type: '修改线段类型',
    straight_segments: '直线',
    curve_segments: '曲线',
    text_contents: '更改文本内容',
    font_family_label: '字体：',
    font_family: '更改字体样式',
    font_size: '更改字体大小',
    bold: '粗体',
    text_decoration_underline: '下划线',
    text_decoration_linethrough: '删除线',
    text_decoration_overline: '上划线',
    italic: '斜体',
    text_anchor_start: '左侧对齐',
    text_anchor_middle: '居中对齐',
    text_anchor_end: '右侧对齐',
    text_letter_spacing: '改变字母间距',
    text_word_spacing: '改变文本间距',
    text_length: '允许你指定文本将绘制到的区域宽度',
    text_length_adjust: '调整长度',
    text_length_adjust_spacing: '间距',
    text_length_adjust_spacing_and_glyphs: '间距和字形',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: '将偏好设置和 SVG 内容本地保存',
    prefs_only: '仅本地保存偏好设置',
    no_prefs_or_content: '不在本地保存我的偏好设置或 SVG 内容',
    jgraduate_pad: '填充间距',
    jgraduate_reflect: '镜像',
    jgraduate_repeat: '重复',
    r_label: 'r',
    x_label: 'x',
    y_label: 'y',
    x1_label: 'x1',
    y1_label: 'y1',
    x2_label: 'x2',
    y2_label: 'y2',
    rx_label: 'rx',
    ry_label: 'ry',
    cx_label: 'cx',
    cy_label: 'cy',
    w_label: 'w',
    h_label: 'h',
    id_label: 'ID',
    class_label: '类',
    label: '标签'
  },
  tools: {
    main_menu: '主菜单',
    bkgnd_color_opac: '更改背景颜色/不透明',
    connector_no_arrow: '无箭头',
    fitToContent: '适应内容',
    fit_to_all: '适应于所有的内容',
    fit_to_canvas: '适应画布',
    fit_to_layer_content: '适应层内容',
    fit_to_sel: '适应选中内容',
    align_relative_to: '相对对齐 ...',
    relativeTo: '相对于:',
    page: '网页',
    largest_object: '最大对象',
    selected_objects: '选中的对象',
    smallest_object: '最小的对象',
    new_doc: '新文档',
    open_doc: '打开文档',
    export_img: '导出',
    save_doc: '保存图像',
    import_doc: '导入SVG',
    align_to_page: '对齐元素到页面',
    align_bottom: '底部对齐',
    align_center: '居中对齐',
    align_left: '左对齐',
    align_middle: '水平居中对齐',
    align_right: '右对齐',
    align_top: '顶端对齐',
    mode_select: '选择工具',
    mode_fhpath: '铅笔工具',
    mode_line: '线工具',
    mode_rect: '矩形',
    mode_square: '正方形',
    mode_fhrect: '自由矩形',
    mode_ellipse: '椭圆',
    mode_circle: '圆形',
    mode_fhellipse: '自由椭圆',
    mode_path: '路径',
    mode_text: '文字工具',
    mode_image: '图像工具',
    mode_zoom: '缩放工具',
    no_embed: '注意: 根据SVG图像的存储位置，内嵌的位图可能无法显示!',
    undo: '撤消',
    redo: '重做',
    tool_source: '编辑源',
    wireframe_mode: '线条模式',
    clone: '克隆元素',
    del: '删除元素',
    group_elements: '组合元素',
    make_link: '创建超链接',
    set_link_url: '设置链接URL (设置为空以删除)',
    to_path: '转换为路径',
    reorient_path: '调整路径',
    ungroup: '取消组合元素',
    docprops: '文档属性',
    editor_homepage: 'SVG-Edit 主页',
    move_bottom: '移至底部',
    move_top: '移至顶部',
    node_clone: '复制节点',
    node_delete: '删除节点',
    node_link: '连接控制点',
    add_subpath: '添加子路径',
    openclose_path: '打开/关闭 子路径',
    source_save: '保存',
    cut: '剪切',
    copy: '复制',
    paste: '粘贴',
    paste_in_place: '粘贴到原位置',
    delete: '删除',
    group: '组合',
    move_front: '移至顶部',
    move_up: '向上移动',
    move_down: '向下移动',
    move_back: '移至底部',
    tool_unlink_use: '断开元素连接',
    ellipse_circle_tool: '椭圆/圆形工具',
    square_rect_tool: '矩形工具',
    remember_this_choice: '记住我的选择',
    remember_this_choice_title: '如果你允许了本地存储并记住本次选择，页面将会刷新并且不再显示该提示',
    flip_horizontal: '水平翻转',
    flip_vertical: '垂直翻转'
  },
  layers: {
    layer: '图层',
    layers: '图层',
    del: '删除图层',
    move_down: '向下移动图层',
    new: '新建图层',
    rename: '重命名图层',
    move_up: '向上移动图层',
    dupe: '复制图层',
    merge_down: '向下合并',
    merge_all: '全部合并',
    move_elems_to: '移动元素至:',
    move_selected: '移动元素至另一个图层'
  },
  config: {
    image_props: '图像属性',
    doc_title: '标题',
    doc_dims: '画布大小',
    included_images: '包含图像',
    image_opt_embed: '嵌入数据 (本地文件)',
    image_opt_ref: '使用文件引用',
    editor_prefs: '编辑器首选项',
    language: '语言',
    background: '编辑器背景',
    editor_img_url: '图像 URL',
    editor_bg_note: '注意: 背景不会保存在图像中.',
    select_predefined: '选择预定义:',
    units_and_rulers: '单位 & 标尺',
    show_rulers: '显示标尺',
    base_unit: '基本单位:',
    grid: '网格',
    snapping_onoff: '吸附开/关',
    snapping_stepsize: '吸附步长:',
    grid_color: '网格颜色',
    done: '完成',
    change_xxx_color: '改变 xxx 颜色',
    pick_paint_opavity: '请选择 {{newValue}} 颜色和不透明度',
    open_color_picker: '点击打开取色器',
    jpicker_title: '拖动标记选择颜色',
    jpicker_new_color: '新',
    jpicker_current_color: '当前',
    jpicker_tooltip_colors_new_color: '新颜色 — 点击“确定”应用此颜色',
    jpicker_tooltip_colors_current_color: '点击恢复为原始颜色',
    jpicker_tooltip_buttons_ok: '确认并应用此颜色选择',
    jpicker_tooltip_buttons_cancel: '取消并恢复为原始颜色',
    jpicker_tooltip_hue_radio: '切换为“色相”颜色模式',
    jpicker_tooltip_hue_textbox: '输入“色相”值（0–360°）',
    jpicker_tooltip_saturation_radio: '切换为“饱和度”颜色模式',
    jpicker_tooltip_saturation_textbox: '输入“饱和度”值（0–100%）',
    jpicker_tooltip_value_radio: '切换为“明度”颜色模式',
    jpicker_tooltip_value_textbox: '输入“明度”值（0–100%）',
    jpicker_tooltip_red_radio: '切换为“红色”颜色模式',
    jpicker_tooltip_red_textbox: '输入“红色”值（0–255）',
    jpicker_tooltip_green_radio: '切换为“绿色”颜色模式',
    jpicker_tooltip_green_textbox: '输入“绿色”值（0–255）',
    jpicker_tooltip_blue_radio: '切换为“蓝色”颜色模式',
    jpicker_tooltip_blue_textbox: '输入“蓝色”值（0–255）',
    jpicker_tooltip_alpha_radio: '切换为“透明度”颜色模式',
    jpicker_tooltip_alpha_textbox: '输入“透明度”值（0–100）',
    jpicker_tooltip_hex_textbox: '输入“十六进制”颜色值（#000000–#ffffff）',
    jpicker_tooltip_hex_alpha: '输入“Alpha”值（#00–#ff）',
    jgraduate_solid_color: '纯色',
    jgraduate_linear_gradient: '线性渐变',
    jgraduate_radial_gradient: '径向渐变',
    jgraduate_begin_point: '起始点',
    jgraduate_enter_starting_x: '请输入起始 X 值（0.0 到 1.0 之间）',
    jgraduate_enter_starting_y: '请输入起始 Y 值（0.0 到 1.0 之间）',
    jgraduate_end_point: '结束点',
    jgraduate_enter_ending_x: '请输入结束 X 值（0.0 到 1.0 之间）',
    jgraduate_enter_ending_y: '请输入结束 Y 值（0.0 到 1.0 之间）',
    jgraduate_center_point: '中心点',
    jgraduate_enter_value_x: '请输入 X 值（0.0 到 1.0 之间）',
    jgraduate_enter_value_y: '请输入 Y 值（0.0 到 1.0 之间）',
    jgraduate_focal_point: '焦点',
    jgraduate_match_center: '匹配中心：',
    jgraduate_enter_focal_x: '请输入焦点 X 值（0.0 到 1.0 之间）',
    jgraduate_enter_focal_y: '请输入焦点 Y 值（0.0 到 1.0 之间）',
    jgraduate_spread_method: '扩散方式',
    jgraduate_radius: '半径：',
    jgraduate_set_radius: '点击设置半径',
    jgraduate_ellip: '椭圆率：',
    jgraduate_set_ellip: '点击设置椭圆率',
    jgraduate_angle: '角度：',
    jgraduate_set_angle: '点击设置角度',
    jgraduate_deg: '度：',
    jgraduate_opac: '不透明度：',
    jgraduate_set_opac: '点击设置不透明度'
  },
  notification: {
    invalidAttrValGiven: '无效的参数',
    noContentToFitTo: '无可适应的内容',
    dupeLayerName: '已存在同名的图层!',
    enterUniqueLayerName: '请输入一个唯一的图层名称',
    enterNewLayerName: '请输入新的图层名称',
    layerHasThatName: '图层已经采用了该名称',
    QmoveElemsToLayer: "您确定移动所选元素到图层'%s'吗?",
    QwantToClear: '您希望清除当前绘制的所有图形吗?\n该操作将无法撤消!',
    QwantToOpen: '您希望打开一个新文档吗?\n该操作将无法撤消!',
    QerrorsRevertToSource: 'SVG文件解析错误.\n是否还原到最初的SVG文件?',
    QignoreSourceChanges: '忽略对SVG文件所作的更改么?',
    featNotSupported: '不支持该功能',
    enterNewImgURL: '请输入新图像的URLL',
    defsFailOnSave: '注意: 由于您所使用的浏览器存在缺陷, 该图像无法正确显示 (不支持渐变或相关元素). 修复该缺陷后可正确显示.',
    loadingImage: '正在加载图像, 请稍候...',
    saveFromBrowser: '在浏览器中右键点击“另存为” ，可将图像保存为{{type}}文件',
    noteTheseIssues: '同时注意以下几点: ',
    unsavedChanges: '存在未保存的修改.',
    enterNewLinkURL: '输入新建链接的URL地址',
    errorLoadingSVG: '错误: 无法加载SVG数据',
    URLLoadFail: '无法从URL中加载',
    retrieving: "检索 '%s'...",
    popupWindowBlocked: '弹出窗口可能被浏览器阻止',
    exportNoBlur: '模糊的元素将显示为未模糊状态',
    exportNoforeignObject: 'foreignObject 元素将不会显示',
    exportNoDashArray: '描边将显示为填充效果',
    exportNoText: '文字显示可能与预期不符',
    editorPreferencesMsg: '默认情况下，只要您的设备支持，SVG-Edit 会将您的编辑偏好设置和 SVG 内容本地保存在您的电脑上，这样您每次重新打开 SVG-Edit 时，就无需再费力重新设置或导入内容了。但如果您出于隐私考虑，不希望这些信息留在您的设备上，只需在下方切换选项，轻松关闭这一默认功能即可！',
    source_dialog_note: '将此框中的内容复制到文本编辑器中，然后以 .svg 为扩展名保存该文件。'
  }
}
